import { mergeProps } from "@base-ui/react/merge-props";
import { useRender } from "@base-ui/react/use-render";
import { measure } from "@obs/tokens/index.stylex.ts";
import type { StyleXStyles } from "@stylexjs/stylex";
import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";

export type DefaultProps = {
	children: ReactNode;
	render?: useRender.ComponentProps<"div">["render"];
	sx?: StyleXStyles;
};

const styles = stylex.create({
	root: {
		display: "flex",
		flexDirection: "column",
		paddingInline: measure.spacingHorizontalDefault,
		paddingBlock: measure.spacingVerticalDefault,
		margin: 0,
		gap: measure.spacingGapDefault,
	},
});

export const Default = ({ children, render, sx }: DefaultProps) => {
	return useRender({
		render: render ?? <div />,
		props: mergeProps<"div">({ children }, stylex.props(styles.root, sx)),
	});
};
